import { Input, Search16 } from '@cian/ui-kit';
import React, { useCallback, useState, VFC } from 'react';
import { Checkbox } from '../../../../Checkbox';
import { CheckboxLabel } from '../../../../CheckboxLabel';
import { getIsSearchValueIncludes } from '../../helpers/getIsSearchValueIncludes';
import * as styles from './DropdownView.css';
import { HandleSearchValueChange, IDropdownViewProps } from './types';

export const DropdownView: VFC<IDropdownViewProps> = props => {
  const { checkboxGroups, checkboxValues, onCheckboxChange } = props;

  const [searchValue, setSearchValue] = useState<string>('');

  const handleSearchValueChange = useCallback<HandleSearchValueChange>((_e, value) => {
    setSearchValue(value);
  }, []);

  const handleCheckboxChange = (groupName: string, value: number) => () => onCheckboxChange(value, groupName);

  let isEmptyAfterSearchItemsList = true;
  const allGroupsAreEmpty = checkboxGroups.getAllGroupsAreEmpty();
  const listItemsView = allGroupsAreEmpty
    ? []
    : checkboxGroups.list.map(checkboxGroup => (
        <li key={checkboxGroup.name} className={styles['list-item']}>
          <ul className={styles['list-inner']}>
            {checkboxGroup.list.reduce((accumulator, checkbox) => {
              if (getIsSearchValueIncludes(searchValue, checkbox.label)) {
                isEmptyAfterSearchItemsList = false;

                const listInnerItem = (
                  <li key={checkbox.value} className={styles['list-inner-item']}>
                    <Checkbox
                      disabled={checkbox.disabled}
                      label={
                        <CheckboxLabel
                          label={checkbox.label}
                          tooltipTitle={checkbox.tooltipTitle}
                          postfixType={checkbox.postfixType}
                        />
                      }
                      checked={checkbox.checkIsActive(checkboxValues)}
                      onChange={handleCheckboxChange(checkboxGroup.name, checkbox.value)}
                    />
                  </li>
                );

                accumulator.push(listInnerItem);
              }

              return accumulator;
            }, Array.of<JSX.Element>())}
          </ul>
        </li>
      ));

  return (
    <div className={styles['container']}>
      <div className={styles['search-input']}>
        <Input onChange={handleSearchValueChange} placeholder="Поиск" value={searchValue} leftEnhancer={<Search16 />} />
      </div>
      {!isEmptyAfterSearchItemsList && <div className={styles['divider']} />}
      {!isEmptyAfterSearchItemsList && <ul className={styles['list']}>{listItemsView}</ul>}
    </div>
  );
};

DropdownView.displayName = 'DropdownView';
